import type { UseQueryOptions } from "@tanstack/react-query";
import { skipToken, useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../../../api";
import urls from "../../../urls";
import type {
  Paragraph6ContractResponse,
  Paragraph6GemeindeAnteilErzeugerResponse
} from "../Paragraph6.types";

export function useParagraph6GemeindeAnteilErzeuger(
  contractId: Paragraph6ContractResponse["id"],
  generatorShareId?: number,
  options?: Partial<
    UseQueryOptions<Paragraph6GemeindeAnteilErzeugerResponse | undefined>
  >
) {
  const {
    data: paragraph6GemeindeAnteilErzeuger,
    isLoading,
    isFetching,
    error
  } = useQuery({
    queryKey: [
      "paragraph6GemeindeAnteilErzeuger",
      { generatorShareId, contractId }
    ],
    queryFn: generatorShareId
      ? () =>
          fetchParagraph6GemeindeAnteilErzeuger(generatorShareId, contractId)
      : skipToken,
    ...options
  });

  return {
    paragraph6GemeindeAnteilErzeuger,
    isLoading,
    isFetching,
    error
  };
}

async function fetchParagraph6GemeindeAnteilErzeuger(
  generatorShareId: number,
  contractId: string
) {
  const paragraph6GemeindeAnteilErzeugerUrl =
    urls.apiWithoutCamelization.paragraph6GemeindeAnteilErzeuger(
      contractId,
      generatorShareId
    );
  const response =
    await apiWithoutCamelization.get<Paragraph6GemeindeAnteilErzeugerResponse>(
      paragraph6GemeindeAnteilErzeugerUrl
    );
  return response.data;
}
